<template>
  <div class="contents">
    <button
      v-if="placement === 'nav'"
      v-show="!mobileMenuOpen"
      type="button"
      class="-m-2.5 cursor-pointer inline-flex items-center justify-center lg:hidden p-2.5 rounded-md text-base-content"
      @click="openMobileMenu"
    >
      <span class="sr-only">
        {{ $t('public.landingMobileNavDrawer.openMainMenu') }}
      </span>

      <Bars3Icon
        class="size-6"
        aria-hidden="true"
      />
    </button>

    <div
      v-else
      v-show="!mobileMenuOpen"
      class="fixed lg:hidden pointer-events-none right-4 top-3 z-(--z-index-ds-hamburger)"
    >
      <button
        type="button"
        class="cursor-pointer dark:text-content-inverse inline-flex items-center justify-center p-2.5 pointer-events-auto rounded-md text-content-level-900"
        @click="openMobileMenu"
      >
        <span class="sr-only">
          {{ $t('public.landingMobileNavDrawer.openMainMenu') }}
        </span>

        <Bars3Icon
          class="size-6"
          aria-hidden="true"
        />
      </button>
    </div>

    <MobileNavDrawer
      :open="mobileMenuOpen"
      @close="closeMobileMenu"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import MobileNavDrawer from '~/components/MobileNavDrawer.vue'

withDefaults(
  defineProps<{
    /** Placement mode for the mobile drawer. */
    placement?: 'nav' | 'fixed'
  }>(),
  { placement: 'nav' }
)

const mobileMenuOpen = ref(false)

const openMobileMenu = () => {
  mobileMenuOpen.value = true
}

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
}
</script>
